import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequirePermission } from "@/components/universal/require-permission";
import NotFoundPage from "@/catchall";

export const Route = createFileRoute("/_private/_warehouse-360")({
  component: WarehouseLayout,
});

function WarehouseLayout() {
  return (
    <RequirePermission permission="warehouse_360" fallback={<NotFoundPage />}>
      <Outlet />
    </RequirePermission>
  );
}
